//normas de convivencia

export const responsables = [
    "Director: Oscar Manuel Gomez Arroyo",
    "Coordinadores de TOE: Rocío del Pilar García Rengifo",
    "Responsable de Convivencia: Adni Jehu Inocente Bonilla",
    "Representante de inclusión: Elena Smith Neyra Bardasles",
    "Representante de estudiante: Steven Henry Viena Saldaña",
    "Representantes padres/madres de familia: Jilma Luz Chávez Merino",
    "Psicólogo DREU: Carlos Augusto Flores Hidalgo",
  ];
  
  export const normasEstudiantes = [
    "Mantenemos el respeto mutuo entre compañeros(as), profesores, profesoras y personal que labora en la institución educativa...",
    "Participamos con disciplina y respeto en las actividades de la institución.",
    "Mantenemos la limpieza en la institución educativa, aulas y cuidamos las áreas verdes.",
    "Ponemos en práctica los valores como el respeto, honradez, responsabilidad y puntualidad.",
    "Cuidamos la infraestructura, los materiales y bienes escolares.",
    "Ingresamos correctamente presentables y puntuales a las clases presenciales.",
    "Respetamos y ponemos en práctica los protocolos de bioseguridad (uso correcto de las mascarillas, lavado de manos, distanciamiento adecuado)",
  ];
  
  export const normasPadres = [
    {
      acuerdo: "Asistir puntualmente a las reuniones convocadas por la Institución Educativa",
      accion: "Serán citadas en el horario atención a Padres de Familia para justificar su inasistencia",
    },
    {
      acuerdo: "Enviar a sus hijos puntualmente a clase en el horario establecido",
      accion: "Exhortan a los Padres de Familia por la tardanza de sus hijos mediante esquela, llamada telefónica",
    },
    {
      acuerdo: "Asistir a la I.E. adecuadamente vestidos.",
      accion: "Exhortan para venir adecuadamente vestidos.",
    },
    {
      acuerdo: "Acompañan diariamente a sus hijos en el proceso educativo.",
      accion: "Asistir al llamado del tutor o docente de las áreas para firmar un compromiso de acompañamiento.",
    },
    {
      acuerdo: "Evitar que sus hijos porten celulares en la Institución Educativa.",
      accion: "Se retendrá los celulares por un mes, en caso de reincidencia hasta fin de año.",
    },
  ];
  
  export const normasDocentes = [
    {
      acuerdo: "Somos puntuales al ingresar a la Institución Educativa y al aula",
      accion: "Firmamos un compromiso de responsabilidad y puntualidad",
    },
    {
      acuerdo: "Entregamos puntualmente los documentos pedagógicos y registros de evaluación.",
      accion: "Firmamos un compromiso de responsabilidad en la entrega de documentos pedagógicos y registro de evaluación.",
    },
    {
      acuerdo: "Mantenemos el celular apagado en vibrador durante las horas de clases",
      accion: "Asume el compromiso de no utilizar indebidamente el celular durante las horas de clases",
    },
    {
      acuerdo: "Asistimos debidamente uniformados y/o formalmente vestidos.",
      accion: "Asumimos el compromiso de venir correctamente vestidos.",
    },
    {
      acuerdo: "Somos respetuosos y amables en el trato con los demás.",
      accion: "Reconocemos nuestra falta y nos disculpamos frente a la persona que ha sufrido el agravio.",
    },
    {
      acuerdo: "Actuamos oportunamente frente a las faltas de los estudiantes.",
      accion: "Asumir positivamente la exhortación para mejorar su actitud.",
    },
    {
      acuerdo: "Nos esmeramos en consolidar el aprendizaje de nuestros estudiantes.",
      accion: "Nos capacitamos continuamente para mejorar nuestro desempeño",
    },
    {
      acuerdo: "Promovemos con nuestros ejemplos el pleno acatamiento del reglamento interno.",
      accion: "Asumimos el compromiso de dar el cumplimiento al reglamento interno.",
    },
    {
      acuerdo: "Velamos por el cuidado de los materiales y enseres de la Institución.",
      accion: "Nos comprometemos en el cuidado de los bienes del colegio.",
    },
    {
      acuerdo: "Participamos en actividades que fortalezcan nuestro desempeño profesional.",
      accion: "Asumimos los compromisos que hemos aceptado para mejorar nuestros desempeños profesionales",
    },
  ];
  